import { GET_FAV_TRADE_PAIR_ERROR, GET_FAV_TRADE_PAIR_LIST, GET_FAV_TRADE_PAIR_REQUEST, UPDATE_FAV_TRADE_PAIR_DATA, REMOVE_FAV_TRADE_PAIR_LIST } from "../../ActionTypes/ActionTypes.js";

const initialState = {
    favTradePairLoading: false,
    favTradePairData: null,
    favTradePairError: null,
    favTradePairStatus: null,
    isModified: false,
    isFirstLoad: true,


};

const favTradePairReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_FAV_TRADE_PAIR_REQUEST:
            return { ...state, favTradePairLoading: true, favTradePairStatus: null, favTradePairData: null };
        case GET_FAV_TRADE_PAIR_LIST:
            return {
                favTradePairLoading: false, favTradePairData: action.payload, favTradePairError: null, favTradePairStatus: action?.payload?.success,

                isFirstLoad: false,
            };

        case GET_FAV_TRADE_PAIR_ERROR:
            return { favTradePairLoading: false, favTradePairData: null, favTradePairError: action?.payload, favTradePairStatus: action?.payload?.success, isFirstLoad: false, };
        case UPDATE_FAV_TRADE_PAIR_DATA:
            return {
                ...state,
                favTradePairData: {
                    ...state.favTradePairData,
                    result: {
                        ...state.favTradePairData.result,
                        ...action.payload,
                    },
                },
            };
        case REMOVE_FAV_TRADE_PAIR_LIST:
            return { ...state, favTradePairData: null, favTradePairError: null, isModified: false, favTradePairStatus: null, isFirstLoad: true, favTradePairLoading: false }
        default:
            return state;
    }
};

export default favTradePairReducer;